// Libraries
import React from 'react';

/**
 * Bootstrap Container
 * 
 * Re-usable component that wraps components in a section tag and the bootstrap div.container and div.row
 * 
 * @since 0.5
 * 
 * @param props 
 * @return {jsx}
 * 
 */
const BootstrapContainer = (props) => {
    const customClass = (props.containerClass !== undefined) ? `${props.containerClass} container` : 'container';

    return(
        <div className={customClass}>
            <div className="row">{ props.children }</div>
        </div>
    )
}

export default BootstrapContainer;
